import getFavItems from "./getFavItems";

export default async (product) => {
    let ret = false;
    await getFavItems().then((feed) => {
        ret = feed.indexOf(product) >= 0;
    })
    return ret;
}
